import React, { useEffect, useRef, useState } from "react";
import { getUUID } from "../../utils/helpers";

const InputFile = ({
  files = [],
  id = "",
  label = "",
  handlerFiles,
  field = "",
  filesCount = undefined,
  label2 = "",
  isRequired = false,
  minFile = 0,
  maxFile = 0,
  classTitle = ""
}) => {
  const [data, setData] = useState("");
  const [countFiles, setCountFiles] = useState({ count: 0, ref: null });

  const textBtn = (count) =>
    count === 1 ? "Un archivo adjunto" : `${count} archivos adjuntos`;

  const txtFoto =
   files.length > 0
      ? textBtn(files.length)
      : "Ningún archivo seleccionado";

  let inputRef = useRef();
  let inputRequiredRef = useRef();
  let btnRef = useRef();

  const hideStyle = {
    height: "0px",
    width: "0px",
    overflow: "hidden",
    opacity: 0
  };

  const cssTitle = " labelComponent mt-20 " + classTitle;


  const handlerClick = () => inputRef.current.click();

  const handlerChange = (obj) => {
    proccesFiles(obj.target.files, obj.target.id);
  };

  const proccesFiles = (_files, id) => {
    const count = _files.length;

    let file = textBtn(count);

   /* btnRef.current.innerHTML = count === 0 ? txtFoto : file;*/

    setData(file);

    handlerFiles(_files, id);

   
  };

  const validateCharacter = (nombre) => {
    let lstChar = ['(', ')', '<', '>', ',', ';', ':', '<', '>', '/', '[', ']', '?', '=','{','}','á','é','ó','ú','Á','É','Í','Ó','Ú'];
    var ExisteCaracter = false;
    lstChar.forEach(function (item) {
        if (!ExisteCaracter)
            ExisteCaracter = nombre.includes(item);
       
    }); 

    return ExisteCaracter;
  }

  useEffect(() => {

   if(isRequired){
     if (inputRef.current){
      let setVal = false;
      let BadName = false;
      inputRef.current.setCustomValidity("");


      
      for (let index = 0; index < files.length; index++) {
   

        if(validateCharacter(files[index].name)){
          if(!BadName)
              BadName = true;
        }
        
      }

     
      if(BadName){
         inputRef.current.setCustomValidity("La imagen no debe contener los siguientes caracteres ()<>,;:\\<>/[]?={}, ni acento en las palabras");
          setVal = true;
      }
     
     
      if (files.length === 0){
        inputRef.current.setCustomValidity("Adjunte una imagen");
        setVal = true;
      }
        if (files.length > maxFile){
          inputRef.current.setCustomValidity( `Solo se permite adjuntar un máximo ${maxFile} archivos` );
          setVal = true;  
        }
      /* if( inputRef.current.id=== "imgIdentificacion"){
        console.log("inputRef.current",inputRef.current.id)
        console.log("isRequired",isRequired);
        console.log("setVal",setVal);
        console.log("files.length",files.length);
       }*/
        
      { isRequired && setVal && (
        <input
          ref={inputRef}
          type="radio"
          name={getUUID()}
          className="sg-switch-validator mt-10"
        />
      )}
    }
          }
  });

  useEffect(() => {
    proccesFiles(files);
  }, [0]);

  const required = files.length === 0 || files.length > 2;
  return (
    <div className="sg-input">
      <label htmlFor={id} className={cssTitle}>{label}</label>
    
   <div className="btn-file2"    >
     <button type="button" className="btn-file2_btn "  ref={btnRef} onClick={handlerClick} >  Seleccionar archivo
     </button>
     <label className="labelTitleHelp w0">{txtFoto}</label>
    </div>
    
      
      <label className="labelTitleHelp mt-5">{label2}</label>
    
      <input
        accept={".png, .jpg, .jpeg"}
        multiple
        style={hideStyle}
        id={id}
        type="file"
        ref={inputRef}
        onChange={handlerChange}
      />
    </div>
  );
};

export default InputFile;
/*


*/ 